import * as types from './types';

const initialState = {
  defaultBuilding: null
};

const buildingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_DEFAULT_BUILDING:
      return {
        ...state,
        defaultBuilding: action.payload
      };
    default:
      return state;
  }
};

export default buildingsReducer;